import AddGraphMenu from "../components/add-graph/AddGraphMenu.vue";
import _Vue from "vue";

const AddGraphPlugin = {
    EventBus: new _Vue(),

    install(Vue) {
        Vue.component("add-graph-menu", AddGraphMenu);

        Vue.prototype.$addGraphMenu = {
            show(position) {
                AddGraphPlugin.EventBus.$emit("show", position);
            },
            hide(force = false) {
                AddGraphPlugin.EventBus.$emit("hide", force);
            },
        };
    },
};

export default AddGraphPlugin;
